module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('h1', {
    staticStyle: {
      "font-size": "25px",
      "text-align": "center"
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "bannersList"
  }, [_c('div', {
    staticClass: "add-banner-header"
  }, [_c('h2', [_vm._v("Banners")]), _c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../../../assets/add-banner.png")
    },
    on: {
      "click": function($event) {
        _vm.showBannerModal('Add')
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._l((_vm.bannerList), function(Banner) {
    return _c('div', {
      key: Banner.id,
      staticClass: "banners"
    }, [_c('div', {
      staticClass: "bannerLandscape",
      attrs: {
        "id": "previewBanners"
      }
    }, [_c('h1', [_vm._v(_vm._s(Banner.Type))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      attrs: {
        "src": Banner.ImageUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "operation"
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": require("../../../assets/edit2.png")
      },
      on: {
        "click": function($event) {
          _vm.showBannerModal('Edit', Banner)
        }
      }
    }), _vm._v(" "), _c('v-popover', {
      attrs: {
        "offset": "16",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "tooltip-target b3",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/delete2.png")
      }
    })]), _vm._v(" "), _c('template', {
      slot: "popover"
    }, [_c('p', [_vm._v("\n                        " + _vm._s(_vm.msg) + "\n                      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "padding-left": "5rem"
      }
    }, [_c('button', {
      staticClass: "btn btn--danger",
      on: {
        "click": function($event) {
          _vm.deleteBanner(Banner)
        }
      }
    }, [_vm._v("Yes")]), _vm._v("\n                             \n                        "), _c('button', {
      directives: [{
        name: "close-popover",
        rawName: "v-close-popover"
      }],
      staticClass: "btn btn--gray"
    }, [_vm._v("No")])])])], 2)], 1)])])])
  }), _vm._v(" "), _c('add-edit-banner', {
    attrs: {
      "show": _vm.showAddEditBannerModal,
      "type": _vm.bannerOpr,
      "bannerData": _vm.bannerData
    },
    on: {
      "saved": _vm.onSaved,
      "closed": _vm.onClosed
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v("\n        File Updated:\n        "), _c('a', {
    attrs: {
      "href": "https://s3-ap-northeast-1.amazonaws.com/static.liverunapp.com/app/v1.json",
      "target": "blank"
    }
  }, [_vm._v("https://s3-ap-northeast-1.amazonaws.com/static.liverunapp.com/app/v1.json")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-size": "15px",
      "display": "flex",
      "width": "10%",
      "align-items": "center"
    }
  }, [_vm._v("Audio Channel A: ")]), _vm._v(" "), _c('text-field', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "name": "channelLinkA",
      "data-vv-value-path": "input",
      "data-vv-name": "channelLinkA"
    },
    model: {
      value: (_vm.channelLinkA),
      callback: function($$v) {
        _vm.channelLinkA = $$v
      },
      expression: "channelLinkA"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "submit-form"
    },
    on: {
      "click": function($event) {
        _vm.onAddChannelA()
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), (_vm.linkAError) ? _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex",
      "margin": "1rem 0rem 0rem 5rem"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.linkAError))])]) : _vm._e(), _vm._v(" "), (_vm.audioChannelA) ? _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex",
      "margin": "1rem 0rem 0rem 5rem"
    }
  }, [_vm._v("\n        saved URL   "), _c('a', {
    attrs: {
      "href": _vm.audioChannelA,
      "target": "blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.audioChannelA))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-size": "15px",
      "display": "flex",
      "width": "10%",
      "align-items": "center"
    }
  }, [_vm._v("Audio Channel B: ")]), _vm._v(" "), _c('text-field', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "name": "channelLinkB",
      "data-vv-value-path": "input",
      "data-vv-name": "channelLinkB"
    },
    model: {
      value: (_vm.channelLinkB),
      callback: function($$v) {
        _vm.channelLinkB = $$v
      },
      expression: "channelLinkB"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "submit-form"
    },
    on: {
      "click": function($event) {
        _vm.onAddChannelB()
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), (_vm.linkBError) ? _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex",
      "margin": "1rem 0rem 0rem 5rem"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.linkBError))])]) : _vm._e(), _vm._v(" "), (_vm.audioChannelB) ? _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex",
      "margin": "1rem 0rem 0rem 5rem"
    }
  }, [_vm._v("\n       saved URL    "), _c('a', {
    attrs: {
      "href": _vm.audioChannelB,
      "target": "blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.audioChannelB))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-size": "15px",
      "display": "flex",
      "width": "10%",
      "align-items": "center"
    }
  }, [_vm._v("Audio Channel C: ")]), _vm._v(" "), _c('text-field', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "name": "channelLinkC",
      "data-vv-value-path": "input",
      "data-vv-name": "channelLinkC"
    },
    model: {
      value: (_vm.channelLinkC),
      callback: function($$v) {
        _vm.channelLinkC = $$v
      },
      expression: "channelLinkC"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "submit-form"
    },
    on: {
      "click": function($event) {
        _vm.onAddChannelC()
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), (_vm.linkCError) ? _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex",
      "margin": "1rem 0rem 0rem 5rem"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.linkCError))])]) : _vm._e(), _vm._v(" "), (_vm.audioChannelC) ? _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex",
      "margin": "1rem 0rem 0rem 5rem"
    }
  }, [_vm._v("\n        saved URL    "), _c('a', {
    attrs: {
      "href": _vm.audioChannelC,
      "target": "blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.audioChannelC))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-size": "15px",
      "display": "flex",
      "width": "10%",
      "align-items": "center"
    }
  }, [_vm._v("Audio Channel D: ")]), _vm._v(" "), _c('text-field', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "name": "channelLinkD",
      "data-vv-value-path": "input",
      "data-vv-name": "channelLinkD"
    },
    model: {
      value: (_vm.channelLinkD),
      callback: function($$v) {
        _vm.channelLinkD = $$v
      },
      expression: "channelLinkD"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "submit-form"
    },
    on: {
      "click": function($event) {
        _vm.onAddChannelD()
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), (_vm.linkDError) ? _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex",
      "margin": "1rem 0rem 0rem 5rem"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.linkDError))])]) : _vm._e(), _vm._v(" "), (_vm.audioChannelD) ? _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex",
      "margin": "1rem 0rem 0rem 5rem"
    }
  }, [_vm._v("\n        saved URL    "), _c('a', {
    attrs: {
      "href": _vm.audioChannelD,
      "target": "blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.audioChannelD))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "1rem",
      "border-radius": "10px",
      "margin-top": "2rem",
      "width": "50%",
      "background": "#f9f9f9"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Mode         \n\n        "), _c('toggle-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "changed-font",
      "width": 85,
      "height": 30,
      "speed": 480,
      "color": {
        checked: '#ff5627',
        unchecked: '#413b94'
      },
      "labels": {
        checked: 'STAGING',
        unchecked: 'LIVE'
      }
    },
    on: {
      "change": function($event) {
        _vm.onToggle()
      }
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "11px",
      "color": "#4a4747"
    }
  }, [_vm._v("ⓘ Do not switch between API environment while live run is happening!")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02498baa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/Settings.vue
// module id = 1763
// module chunks = 1